/**
 * Created with JetBrains WebStorm.
 * User: sebastienbeaujard
 * Date: 28/07/13
 * Time: 09:23
 * To change this template use File | Settings | File Templates.
 */

angular.module('FlexyBeautyApp.controllers').
    controller('HrTrashCtrl', ["$rootScope", "$scope", "HumanResourceData", "HumanResourceView", function($rootScope,$scope,HumanResourceData,HumanResourceView)
{
    $scope.dd.loading = false;

    $scope.$watch('ad.dataLoaded', function(newValue, oldValue) {
        if(newValue && !$scope.dd.initTrashView) {
            $scope.initView();
        }
    });

    $scope.initView = function()
    {
        $scope.dd.view.humanResourcesDeletedView = [];
        var humanResourcesDeleted =  HumanResourceData.getDeletedList();
        for(var i=0;i<humanResourcesDeleted.length;i++)
            $scope.dd.view.humanResourcesDeletedView.push(new HumanResourceView(humanResourcesDeleted[i],HumanResourceData.getIndexOf(humanResourcesDeleted[i]),$scope));
        $scope.dd.loading = false;
        $scope.dd.initTrashView = true;
    };
    $scope.restore  = function(hrView)
    {
        if (hrView)
        {
            if (hrView != -1) { // retrieve old value from server
                //hrView.restoreModelAndUpdateOrder(HumanResourceData.getActiveList().length);
                hrView.restoreModel();
                hrView.order = HumanResourceData.getActiveList().length - 1;
                hrView.updateModel();
            }
            var index = $scope.dd.view.humanResourcesDeletedView.indexOf(hrView);
            if (index!=-1)
            {
                $scope.dd.view.humanResourcesDeletedView.splice(index,1);
                $scope.dd.view.humanResourcesActiveView.push(hrView) ;
                if (hrView.hasPlanning)
                    $scope.dd.view.humanResourcesView.push(hrView);
            }
        }
    };
}]);


// WEBPACK FOOTER //
// ./js/controllers/pro/configuration/hr/hrTrashCtrl.js